import { Route } from 'vue-router';
import { getModule } from 'vuex-module-decorators';
import { store } from '@/store';
import LoanStore from '@/loan/store';
import { LoanAPIService } from '@/loan/services/api';

const loanStore = getModule(LoanStore, store);

export const loanRecurringPaymentResolver = async (to: Route): Promise<void> => {
	const { loanId } = to.params;
	const recurringPayment = await LoanAPIService.getRecurringPayment(loanId);
	const availableDates = await LoanAPIService.getRecurringPaymentAvailableDates(loanId);

	loanStore.setRecurringPayment(recurringPayment);
	loanStore.setRecurringPaymentAvailableDates(availableDates);
};
